/* eslint-disable import/no-cycle */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { generatePath, Link } from 'react-router-dom';

import {
  Layout,
  Row,
  Col,
  Form,
  Tooltip,
  Icon,
  Table,
  Button,
  Dropdown,
  Menu,
  Input,
  Tag,
  Divider,
  Modal,
  Select,
  notification,
} from 'antd';

import { connect } from 'react-redux';
import axios, { CancelToken } from 'axios';
import { pathRoutes } from '../../routes';
import { stringsHelp } from '../../helpers';
import { eventsService } from '../../services';
import ImportTransEventPresets from '../ImportTransEventPresets';
import { techniquesService } from '../../services';
import {techniqueActions} from '../../actions'

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

class Techniques extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    modalVisiblePreset: false,
    confirmVisible: false,
    confirmLoading: false,
    deleteId: undefined,
    dataEvents: [],
    addDropdownArrow: 'down',
    techniqueId: '',
    categoryId: null,
    search: '',
    searchInterval: null,
    count: 0,
    techniqueCategories: [],
    loadingCategories: false,
    pagination: {
      defaultPageSize: 10,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ['10', '30', '50', '100'],
      onChange: (page, pageSize) => this.changePage(page, this.state.search, pageSize),
      onShowSizeChange: (current, size) => this.changePageSize(current, size),
    },
  };

  cancelSource = CancelToken.source();

  componentDidMount() {
    this.loadMap();
    this.loadTechniqueCategories();
  }

  loadMap = () => {
    const { dispatch, techniques } = this.props;
    const { search } = this.state;

    if (techniques.loading) {
      this.cancelSource.cancel();
      this.cancelSource = CancelToken.source();
    }

    const objFilter = {
      category_id: this.state.categoryId
    }

    const searchLocalStorage = localStorage.getItem('searchText');
    const currentPageLocalStorage = localStorage.getItem('currentPage');

    if (searchLocalStorage) {
      objFilter.search = searchLocalStorage;
      this.setState({ search: searchLocalStorage });
      localStorage.removeItem('searchText');
    } else objFilter.search = search;

    if (currentPageLocalStorage) {
      this.page = currentPageLocalStorage;
      localStorage.removeItem('currentPage');
    }

    Promise.all([
      dispatch(
        techniqueActions.getTechniques(
          objFilter,
          this.page || 1,
          this.state.pagination.pageSize,
          this.cancelSource.token
        )),
      techniquesService.countTechniques(objFilter, this.cancelSource.token)
    ]).then(([techniques,total]) => {
      this.setState({
        dataEvents: techniques,
        count: total.count,
        pagination: {
          ...this.state.pagination,
          total: total.count,
          current: this.page || 1,
        },
      });
    });
  }

  loadTechniqueCategories = async () => {
    this.setState({ loadingCategories: true });
    try {
      const data = await techniquesService.getTechniqueCategories(this.cancelSource ? this.cancelSource.token : undefined);
      this.setState({
        techniqueCategories: data,
        loadingCategories: false,
      });
    } catch {
      this.setState({
        techniqueCategories: [],
        loadingCategories: false,
      });
    }
  };


  changePageSize = (currentPage, pageSize) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        pageSize,
      },
    }, () => {
      this.changePage(currentPage, this.state.search, pageSize);
    });
  };

  showConfirm = (id) => {
    this.setState({
      confirmVisible: true,
      confirmLoading: false,
      deleteId: id,
    });
  };

  handleDelete = () => {
    const { deleteId } = this.state;
    if (!Number.isInteger(deleteId) || deleteId < 0) return;

    let promiseDelete;
    if (deleteId) {
      this.setState({confirmLoading:true});

      promiseDelete = techniquesService
        .deleteTechnique(deleteId)
        .then(() => {
          notification.success({
            message: 'Técnica removida com sucesso!'
          })

          this.loadMap();

          this.setState({
            confirmLoading: false,
            confirmVisible: false,
            deleteId: null,
          })
        });
    }
  };

  searchTable = (e) => {
    this.setState({ search: e.target.value });

    setTimeout(() => {
      this.loadMap();
    }, 500);
  };

  setCategory = (value) => {
    this.setState({ categoryId: value || null });

    clearTimeout(this.categoryTimeout);

    this.categoryTimeout = setTimeout(() => {
      this.loadMap();
    }, 500);
  };

  changePage = (page, filter, pageSize = this.state.pagination.pageSize) => {
    this.cancelSource.cancel();
    this.cancelSource = CancelToken.source();
    const objFilter = {
      category_id: this.state.categoryId,
      search: filter,
    };
    let location;
    if (filter) {
      location = generatePath(pathRoutes.techniques, { page, filter });
    } else {
      location = generatePath(pathRoutes.techniques, { page });
    }
    this.props.history.push(location);

    const { dispatch } = this.props;

    this.page = page;
    this.filterValue = filter;

    Promise.all([
      techniquesService.getTechniques(
        objFilter,
        page,
        pageSize,
        this.cancelSource.token
      ),
      techniquesService.countTechniques(
        objFilter,
        this.cancelSource.token
      )
    ])
      .then(([listResponse, countResponse]) => {
        this.setState({
          dataEvents: listResponse,
          count: countResponse.count,
          pagination: {
            ...this.state.pagination,
            total: countResponse.count,
            pageSize,
            current: page,
          },
        });
      })
      .catch(error => {
        if (axios.isCancel(error)) return;
        console.error(error);
      });
  };

  addArrowChange = (a) => {
    if (a) {
      this.setState({ addDropdownArrow: 'up' });
    } else {
      this.setState({ addDropdownArrow: 'down' });
    }
  };

  setModalVisiblePreset = (modalVisiblePreset) => {
    this.setState({ modalVisiblePreset });
    this.addArrowChange(false);
    if (!modalVisiblePreset) {
      this.loadMap();
    }
  };

  render() {
    const { techniques } = this.props;
    const columnsTableEvents = [
      {
        title: 'Nome',
        dataIndex: 'name',
        key: 'name',
        render: (name, record) => (
          <div>
            {/* <h4 style={{ color: '#343f5c' }}>
              {name}
            </h4> */}
            <Tooltip title="Nome">
              {name}
            </Tooltip>
          </div>
        ),
      },
      {
        title: 'Descrição',
        dataIndex: 'description',
        key: 'description',
        render: (description, record) => (
          <div>
            <Tooltip title="Descrição">
              {record.description && record.description && stringsHelp.wordLimiter(record.description, 4, false)}
            </Tooltip>
          </div>
        ),
      },
      {
        title: 'Categoria',
        dataIndex: 'technique_category_id',
        key: 'category_id',
        render: (category, record) => (
          <div>
            {/* <h4 stle={{ color: '#343f5c' }}>
              {record.anesthetic_technique_category.name}
            </h4> */}
            <Tag key={record.id}>{record.anesthetic_technique_category.name}</Tag>
            {/* <Tooltip title="Categoria">
              {stringsHelp.wordLimiter(record.anesthetic_technique_category.name, 4, false)}
            </Tooltip> */}
          </div>
        ),
      },
      {
        title: '',
        key: 'actions',
        align: 'right',
        dataIndex: 'id',
        width: 80,
        render: (id, record) => (
          <span>
            <Button type="link" onClick={() => {
              localStorage.setItem('searchText', this.state.search);
              localStorage.setItem('currentPage', this.page ? this.page : 1);
            }}>
              <Link to={`${pathRoutes.editTechnique.replace('/:id', '')}/${id}`}>
                <Icon type="edit" />
              </Link>
            </Button>
            <Divider type="vertical" />
            <Button type="link" onClick={() => this.showConfirm(record.id)}>
              <Icon type="delete" />
            </Button>
          </span>
        ),
      },
    ];

    return (
      <Content>
        <ImportTransEventPresets
          visible={this.state.modalVisiblePreset}
          setVisible={this.setModalVisiblePreset}
        />
        <Row>
          <Col xs={24} sm={24} lg={24} xl={0}>
            <Button
              type="primary"
              size="large"
              shape="circle"
              className="add-procedure"
              onClick={() => this.props.history.push({ pathname: pathRoutes.newTechnique })}
            >
              <Icon type="plus" fill="#ffffff" />
            </Button>
          </Col>

          <Col xs={24} sm={10} lg={24} xl={8}>
            <h1 className="title">Técnicas Anestésicas</h1>
          </Col>
          <Col xs={24} lg={24} xl={16}>
            <Row>
              <Col
                xs={24}
                lg={24}
                sm={24}
                xl={10}
                xxl={8}
                // style={{ paddingRight: 5, paddingLeft: 5, paddingBottom: 5 }}
              >
                <Select
                  allowClear
                  placeholder="Todas as categorias"
                  loading={this.state.loadingCategories}
                  style={{ width: '100%' }}
                  onChange={(e) => this.setCategory(e)}
                  showAction={['click']}
                >
                  {this.state.techniqueCategories.map((cat) => (
                    <Option key={cat.uuid} value={cat.id}>
                      {cat.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col
                xs={24}
                lg={24}
                sm={24}
                xl={10}
                xxl={12}
                style={{ paddingRight: 5, paddingLeft: 5, paddingBottom: 5 }}
              >
                <Search
                  placeholder="Buscar"
                  value={this.state.search}
                  onChange={this.searchTable}
                  style={{ width: '100%' }}
                />
              </Col>
              <Col xs={0} sm={0} md={0} lg={0} xl={4} xxl={4}>
                <div style={{ display: 'flex', alignItems: 'right', justifyContent: 'right' }}>
                  <Button type="primary" shape="round" className="add-procedure" style={{ width: '100%' }} onClick={()=> this.props.history.push({ pathname: pathRoutes.newTechnique })}>
                    ADICIONAR
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>

        </Row>
        <Row>
          <Table
            rowKey="id"
            size="midle"
            loading={techniques.loading}
            dataSource={this.state.dataEvents}
            columns={columnsTableEvents}
            pagination={this.state.pagination}
            footer={() => {
              const rowsDataSource = !this.state.count
                ? 0
                : this.state.count;
              return (
                <span>
                  Total de registros:
                  {' '}
                  <Tag>{rowsDataSource}</Tag>
                </span>
              );
            }}
          />
        </Row>

        <Modal
          title=""
          visible={this.state.confirmVisible}
          onOk={() => this.handleDelete()}
          okText="Sim"
          okType="primary"
          cancelText="Não"
          confirmLoading={this.state.confirmLoading}
          onCancel={() => this.setState({ confirmVisible: false })}
        >
          <p style={{ fontSize: 14, fontWeight: 700 }}>
            <span style={{ fontSize: 24, color: '#ffcd56', marginRight: 10 }}>
              <Icon type="question-circle" />
            </span>
            {' '}
            Confirma remover a Técnica ?
          </p>
        </Modal>
      </Content>
    );
  }
}

function mapStateToProps(state) {
  const { techniques } = state;
  return {
    techniques,
  };
}

const connected = connect(mapStateToProps)(Form.create()(Techniques));
export default connected;
